// extracted by css-extract-rspack-plugin
export default {"flowIcon":"flowIcon-PJ1R4Q"};